import React from "react";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";

const CityList = () => {
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Code",
      accessorKey: "code",
      cell: NACell,
    },
    {
      header: "District",
      accessorKey: "district_name.name",
      cell: NACell,
    },
    {
      header: "State",
      accessorKey: "state_name.name",
      cell: NACell,
    },
    {
      header: "Country",
      accessorKey: "country_name.name",
      cell: NACell,
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={`${APIS.LOCATION}flat-location/`}
      queryKey={"cities"}
      columns={defaultColumns}
      params={{ level: 3 }}
      addNewPagePath={"/create-city"}
      tableName={"City"}
    />
  );
};

export default CityList;
